module.exports = __webpack_public_path__ + "img/2026-id.8b1ddff9.webp";